/**
 * Техническое устройство
 */
import {UploadedFile} from '@interfaces/file.interface';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {DynamicFields} from '@namespaces/dynamic-fields.namespace';
import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import {RadioValueInterface} from '@components/form-field/form-radio-buttons/form-radio-buttons.component';

export namespace TechnicalDeviceNamespace {

    /**
     * Данные формы технического устройства
     */
    export interface DeviceFormInterface {
        /**
         * Участок работ
         */
        location: string;

        /**
         * Id объекта контроля
         */
        object_id: number;

        /**
         * Id типа технического устройства
         */
        type_id: number;

        status: StatusesEnum;
        title: string;
    }

    /**
     * Данные в исходном виде или репрезентере, полученные от API
     */
    export interface ApiDataInterface extends DeviceFormInterface {
        id: number;

        /**
         * Объект контроля для технического устройства
         */
        object: {
            id: number
            number: string;
            title: string;
        };

        /**
         * Тип технического устройства
         */
        type: {
            id: number;
            name: string;
        };

        /**
         * Название объекта, к которому относится ТУ
         */
        working_object: WorkingObjectNamespace.ListItem;
    }

    /**
     * Документация технического устройства
     */
    export interface DeviceDocumentation {
        id: number;
        type: number;
        type_title: string;
        name: string;
        files: UploadedFile[];
    }

    /**
     * Подписи к статусам написаны ниже
     */
    export enum StatusesEnum {
        new = 1,
        inWork,
        controlEnded,
        dataPassed,
        workAccepted
    }

    /**
     * Список статусов (используется в селекте смены статуса)
     */
    export const StatusesList: {id: number, title: string}[] = [
        {id: StatusesEnum.new,           title: 'Новый'},
        {id: StatusesEnum.inWork,        title: 'В работе'},
        {id: StatusesEnum.controlEnded,  title: 'Контроль закончен'},
        {id: StatusesEnum.dataPassed,    title: 'Переданы материалы'},
        {id: StatusesEnum.workAccepted,  title: 'Приняты работы'},
    ];

    /**
     * Тип технического устройства.
     * Используется для выбора в селекте, поэтому расширяет интерфейс.
     */
    export interface TechnicalDeviceTypeInterface extends SelectValueInterface {
        params?: DynamicFields.Field[];
    }

    /**
     * Тип группы (категория, типоразмер) элементов
     * Используется для выбора в селекте, поэтому расширяет интерфейс.
     */
    export interface ElementGroupTypeInterface extends SelectValueInterface {
        params?: DynamicFields.Field[];
    }

    /**
     * Список групп элементов на выбор, с динамическими полями, присущими этой группе
     */
    export interface ElementGroupSelectInterface extends SelectValueInterface {
        params?: DynamicFields.Field[];
    }

    /**
     * НТД для типоразмера
     * Используется для выбора в селекте, поэтому расширяет интерфейс.
     */
    export interface ElementGroupStandardTechnicalDocumentsInterface extends SelectValueInterface {
        params?: DynamicFields.Field[];
    }

    /**
     * Тип элемента ТУ (планируемый элемент)
     */
    export interface ElementGroupInterface {
        id: number;
        /**
         * Наименование типа элементов
         */
        type_title: string;

        /**
         * Введенное наименование поля
         */
        title: string;
        count: number;
        type_id: number;
        /**
         * Динамически параметры, присущие выранному типу элементов
         */
        params: DynamicFields.FieldFormValue[];
        technical_cards: ElementGroupTechcardInterface[];

        /**
         * Максимальное количество возможных техкарт
         */
        industrial_methods_count: number;

        technical_device_id: number;
        ntd_id: number;
    }

    export interface TechnicalCardDocument {
        number: number;
        date: string;
        file: UploadedFile;
    }

    /**
     * Техкарта
     */
    export interface ElementGroupTechcardInterface {
        id: number;
        industry_method_id: number;
        method: {
            id: number;
            title: string;
            short_title: string;
        };
        document: TechnicalCardDocument;
        amount_of_work: number;
        /**
         * Требуемые уровни удостоверений
         */
        certificate_levels: number[];
    }

    /**
     * Элемент контроля, на который выдается заключение
     */
    export interface Element {
        id: number;
        number: string;
        group_title: string;
        group_id: number;
        params: DynamicFields.FieldFormValue[];
        conclusions: ConclusionTechcardRecord[];
        order: {
            date: string;
            number: string;
        };
    }

    export interface ConclusionTechcardRecord {
        technical_card: ElementGroupTechcardInterface;
        conclusion: ConclusionListItem;
    }

    /**
     * Данные по заключению в списке
     */
    export interface ConclusionListItem {
        id: number;
        number: string;
        date: string;
        status_title: string;
        scan: UploadedFile;
        /**
         * id сгенерированного файла документа
         */
        document: number;
        with_inspections: boolean;
    }


    /**
     * Интерфейс сводной информации по техническому устройству
     */
    export interface SummaryInfo {
        groupsCount: number;
    }


    export enum ElementControlOrderFormTypes {
        noOrder = 1,
        newOrder,
        existedOrder,
    }

    export const ElementControlOrderFormRadioValues: RadioValueInterface[] = [
        {value: ElementControlOrderFormTypes.noOrder, title: 'Без заявки'},
        {value: ElementControlOrderFormTypes.newOrder, title: 'Создать заявку'},
        {value: ElementControlOrderFormTypes.existedOrder, title: 'Выбрать существующую заявку'},
    ];
}
